import { cn } from 'lib/utils';

interface WorkingKaomojiProps {
  kaomoji: string;
  className?: string;
  style?: React.CSSProperties;
}

export function WorkingKaomoji({ kaomoji, className, style }: Readonly<WorkingKaomojiProps>) {
  return (
    <span
      className={cn(
        'working-kaomoji shrink-0 text-[17px] leading-none text-[#27272C]/80 dark:text-foreground/80',
        className,
      )}
      style={style}
      aria-hidden
    >
      {kaomoji}
    </span>
  );
}
